import { AbstractControl, ValidatorFn } from '@angular/forms';

export const recommendGuestAverageRatingValidator = (
  maxStarsAllowedForNotRecommending: number,
): ValidatorFn => {
  return (control: AbstractControl) => {
    const isRecommended = control.value;
    const averageRating = (
      (control.parent?.get('cleanliness')?.value || 0) +
      (control.parent?.get('communication')?.value || 0) +
      (control.parent?.get('respectHouseRules')?.value || 0)
    ) / 3;

    if (!isRecommended && averageRating >= maxStarsAllowedForNotRecommending) {
      return { negativeReviewPositiveRating: true };
    }

    return null;
  }
};
